import { Separator } from "@/components/ui/separator";
import { Skeleton } from "@/components/ui/skeleton";
export function LoraDetailsSkeleton() {
  return <div className="container mx-auto px-4 py-6 md:py-8" data-sentry-component="LoraDetailsSkeleton" data-sentry-source-file="index.tsx">
            <div className="bg-slate-900 backdrop-blur-lg text-gray-100 rounded-lg overflow-hidden shadow-2xl border border-slate-700">
                <div className="relative h-64 md:h-96">
                    <Skeleton className="w-full h-full" data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />
                    <div className="absolute bottom-4 right-4">
                        <Skeleton className="h-8 w-32" data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />{" "}
                        {/* Update Cover button */}
                    </div>
                </div>
                <div className="p-4 md:p-6">
                    <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-4 space-y-4 md:space-y-0">
                        <Skeleton className="h-8 w-64 md:w-96" data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />{" "}
                        {/* LORA name */}
                        <div className="flex flex-wrap items-center gap-2 md:gap-4">
                            <Skeleton className="h-8 w-20" data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />{" "}
                            {/* Like button */}
                            <Skeleton className="h-8 w-24" data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />{" "}
                            {/* Visibility button */}
                            <Skeleton className="h-8 w-8" data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" /> {/* Edit button */}
                            <Skeleton className="h-8 w-36" data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />{" "}
                            {/* Use This LORA button */}
                        </div>
                    </div>
                    <Skeleton className="h-20 w-full mb-4" data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />{" "}
                    {/* Short description */}
                    <div className="mb-6">
                        <Skeleton className="h-6 w-24 mb-2" data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />{" "}
                        {/* Created By text */}
                        <div className="flex items-center space-x-4">
                            <Skeleton className="h-12 w-12 rounded-full" data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />{" "}
                            {/* User avatar */}
                            <div>
                                <Skeleton className="h-5 w-32 mb-1" data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />{" "}
                                {/* User name */}
                                <Skeleton className="h-4 w-24" data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />{" "}
                                {/* User details */}
                            </div>
                        </div>
                    </div>
                    <div className="mb-4">
                        <Skeleton className="h-6 w-32 mb-2" data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />{" "}
                        {/* Trigger Words text */}
                        <Skeleton className="h-8 w-32 rounded-full" data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />{" "}
                        {/* Trigger word badge */}
                    </div>
                    <div className="mb-6">
                        <Skeleton className="h-4 w-48 mb-1" data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />{" "}
                        {/* Created date */}
                        <Skeleton className="h-4 w-48" data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />{" "}
                        {/* Last updated date */}
                    </div>
                    <Separator className="my-6 bg-gradient-to-r from-blue-700 to-sky-500 h-px" data-sentry-element="Separator" data-sentry-source-file="index.tsx" />
                    {/* Commented out Comments section skeleton */}
                    {/* <div className="mt-6">
                     <Skeleton className="h-6 w-32 mb-4" /> 
                     <div className="space-y-4 mb-4">
                     {[1, 2, 3].map((i) => (
                     <div key={i} className="flex space-x-3">
                     <Skeleton className="h-10 w-10 rounded-full" />
                     <div>
                     <Skeleton className="h-4 w-32 mb-1" />
                     <Skeleton className="h-3 w-24 mb-2" />
                     <Skeleton className="h-4 w-full" />
                     </div>
                     </div>
                     ))}
                     </div>
                     <div className="flex space-x-2">
                     <Skeleton className="h-10 flex-grow" />
                     <Skeleton className="h-10 w-20" />
                     </div>
                     </div> */}
                </div>
            </div>
        </div>;
}